module.exports = __webpack_public_path__ + "img/royal.717b35cc.png";